{
  "flash": {
    "expired": "This request has expired. No further changes can be made, and your most recent decision is final.",
    "accepted": "You have accepted this request.",
    "rejected": "You have rejected this request."
  },
  "index": {
    "title": "Transfers Requests",
    "empty_list_title": "No Transfer Requests",
    "empty_class_description": "This class has not gone live.",
    "empty_list_description": "There are no transfer requests for this class.",
    "priority_title": "Priority {{rank}} #{{instance}}",
    "accept": "Accept",
    "reject": "Reject",
    "expires_at": "Expires at",
    "state": "State"
  },
  "state": {
    "pending": "Pending",
    "accepted": "Accepted",
    "rejected": "Rejected",
    "cancelled": "Cancelled"
  }
}
